import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';

export class User extends BaseModel {
    id: number;
    username: string;
    password: string;
    email: string;
    accessToken: string;
    roles: number[];
    pic: string;
    sexe: number;
    nom: string;
    prenom: string;
    nomMarital: string;
    naissance: [];
    fullname: string;
    occupation: string;
	phone: string;
    address: Address;
    lists: any[];
    droits: any[];
    rights: any[];
    environnement: string;
    signature:string;
    signature_text:string;
    signature_url:string;
    signature_etat:number;
	type:string;
    clear(): void {
        this.id = undefined;
        this.username = '';
        this.sexe = undefined;
        this.nom = '';
        this.prenom = '';
        this.nomMarital = '';
        this.naissance = [];
        this.password = '';
        this.email = '';
        this.roles = [];
        this.fullname = '';
        this.accessToken = '';
        this.pic = './assets/media/users/default.jpg';
        this.phone = '';
        this.address = new Address();
        this.address.clear();
        this.lists = [];
        this.environnement = "";
        this.droits = [];
        this.rights = [];
        this.signature = "";
        this.signature_text = "";
        this.signature_url = "";
        this.signature_etat = 0;
		this.type='';
    }
}
